import { EAmenities } from 'shared/types/coworking';

import { amenitiesIcons } from './constants';

export const getAmenityItem = (amenity: EAmenities) => {
  switch (amenity) {
    case EAmenities.BikeParking:
      return { key: 'bike_parking', icon: amenitiesIcons.bike_parking, title: 'Велопарковка' };
    case EAmenities.Cafe:
      return { key: 'cafe', icon: amenitiesIcons.cafe, title: 'Кафе' };
    case EAmenities.Cleaning:
      return { key: 'cleaning', icon: amenitiesIcons.cleaning, title: 'Клининг' };
    case EAmenities.Events:
      return { key: 'events', icon: amenitiesIcons.events, title: 'Участие в мероприятиях' };
    case EAmenities.Fax:
      return { key: 'fax', icon: amenitiesIcons.fax, title: 'Факс' };
    case EAmenities.Flipchart:
      return { key: 'flipchart', icon: amenitiesIcons.flipchart, title: 'Флипчарт' };
    case EAmenities.Fruits:
      return { key: 'fruits', icon: amenitiesIcons.fruits, title: 'Фрукты и закуски' };
    case EAmenities.Furniture:
      return { key: 'furniture', icon: amenitiesIcons.furniture, title: 'Мебель' };
    case EAmenities.Gym:
      return { key: 'gym', icon: amenitiesIcons.gym, title: 'Спорт-зал' };
    case EAmenities.Internet:
      return { key: 'internet', icon: amenitiesIcons.internet, title: 'Высокоскоростной интернет' };
    case EAmenities.Kitchen:
      return { key: 'kitchen', icon: amenitiesIcons.kitchen, title: 'Кухня' };
    case EAmenities.LegalAddress:
      return { key: 'legal_address', icon: amenitiesIcons.legal_address, title: 'Юридический адрес' };
    case EAmenities.Lockers:
      return { key: 'lockers', icon: amenitiesIcons.lockers, title: 'Шкафчики' };
    case EAmenities.MeetingRoom:
      return { key: 'meeting_room', icon: amenitiesIcons.meeting_room, title: 'Переговорные комнаты' };
    case EAmenities.Modern:
      return { key: 'modern', icon: amenitiesIcons.modern, title: 'Современный ремонт' };
    case EAmenities.Parking:
      return { key: 'parking', icon: amenitiesIcons.parking, title: 'Парковка' };
    case EAmenities.PhoneBooth:
      return { key: 'phone_booth', icon: amenitiesIcons.phone_booth, title: 'Телефонные будки' };
    case EAmenities.Printer:
      return { key: 'printer', icon: amenitiesIcons.printer, title: 'Принтер и сканер' };
    case EAmenities.Reception:
      return { key: 'reception', icon: amenitiesIcons.reception, title: 'Ресепшн' };
    case EAmenities.RestZone:
      return { key: 'rest_zone', icon: amenitiesIcons.rest_zone, title: 'Зоны отдыха' };
    case EAmenities.Security:
      return { key: 'security', icon: amenitiesIcons.security, title: 'Охрана' };
    case EAmenities.Tea:
      return { key: 'tea', icon: amenitiesIcons.tea, title: 'Чай/кофе' };
    case EAmenities.TechSupport:
      return { key: 'tech_support', icon: amenitiesIcons.tech_support, title: 'Техническая поддержка' };
    case EAmenities.Wifi:
      return { key: 'wifi', icon: amenitiesIcons.wifi, title: 'Wi-Fi' };

    default:
      return undefined;
  }
};
